import React, {useEffect, useState} from 'react';
import Backdrop from "@mui/material/Backdrop";
import {Box, Fade, IconButton, Modal, Typography} from "@mui/material";
import {file, menu, moneyT,} from "../translate";
import Api from "../Api";
import CloseIcon from '@mui/icons-material/Close';

import {greenTheme, style} from "../helpers/style";


function MoneyChange({open, setOpen}) {
    const primaryColor = process.env.REACT_APP_SERVER === 'ATS' ? '#0973b9' : greenTheme.primary;
    const [money, setMoneyChange] = useState([])

    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.moneyHistory()
                setMoneyChange(data.price_history)
            } catch (e) {

            }
        })()
    }, [])
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={{...style, position: 'relative', borderRadius: '12px', overflow: 'hidden'}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                        aria-label="Close"
                        sx={{
                            position: 'absolute',
                            right: -56,
                            top: 24,
                            zIndex: 1,
                            width: 56,
                            height: 40,
                            borderRadius: '0 12px 12px 0',
                            backgroundColor: primaryColor,
                            color: '#fff',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            '&:hover': {backgroundColor: primaryColor, opacity: 0.9, color: '#fff'},
                        }}
                    >
                        <CloseIcon sx={{fontSize: 20}}/>
                    </IconButton>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {menu.amount[+localStorage.getItem('atsLang')  || 1]}
                        </Typography>
                    </div>
                    <Box
                        sx={{
                            maxHeight: 'calc(90vh - 150px)',
                            overflowY: 'auto',
                            pr: 1,
                            '&::-webkit-scrollbar': {width: '6px'},
                            '&::-webkit-scrollbar-track': {background: 'transparent'},
                            '&::-webkit-scrollbar-thumb': {
                                background: '#cbd5e1',
                                borderRadius: '8px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#94a3b8',
                            },
                            scrollbarWidth: 'thin',
                            scrollbarColor: '#cbd5e1 transparent',
                        }}
                    >
                        {money.length ? money.map((m, _) => (
                            <div  key={_}>
                                <div align="center" style={{padding: '10px 15px'}}>
                                    {m.service.split(',').map((l,i) => (
                                        <p>{moneyT[l][+localStorage.getItem('atsLang')  || 1]}  {+m.total_price.split(',')[i]}</p>
                                    ))}
                                    <b>Total</b> - {m.total_price.split(',').reduce((accumulator, currentValue) => +accumulator + +currentValue, 0)}
                                </div>
                                <div align="center" style={{padding: '10px 15px'}}>
                                    <b>Changed at</b> - {new Date(m.sdate).toLocaleString()}
                                </div>
                                <hr/>
                            </div>
                        )) : <div align="center" style={{padding: '10px 15px'}}>
                            no data
                        </div>}

                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default MoneyChange;
